import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Facebook,
  Instagram,
  Youtube,
  Mail,
  Phone,
  MapPin,
  Calendar,
  ChevronRight,
  Linkedin,
  Twitter,
  X,
} from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="bg-gray-900 text-white">
        <div className="container mx-auto px-6">
          <div className="pt-16 pb-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-20">
            {/* Column 1: About */}
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <img className="h-10 w-auto" src="/logo.png" alt="NASTP Logo" />
                <div className="flex flex-col">
                  <span className="text-xl font-bold text-white">NIIT</span>
                  <span className="text-xs text-gray-400">
                    NASTP Institute of Information Technology
                  </span>
                </div>
              </div>
              <p className="text-gray-400 mb-6">
                Empowering the future through technology education since 2023.
              </p>
              <div className="flex space-x-4">
                <a
                  target="_blank"
                  href="https://www.facebook.com/p/NASTP-Institute-of-Information-Technology-Lahore-61551740357785/"
                  className="text-gray-400 hover:text-white transition-colors duration-300"
                >
                  <Facebook className="h-8 w-8" />
                </a>
                <a
                  target="_blank"
                  href="https://www.instagram.com/niit.official/"
                  className="text-gray-400 hover:text-white transition-colors duration-300"
                >
                  <Instagram className="h-8 w-8" />
                </a>
                <a
                  target="_blank"
                  href="https://www.youtube.com/@nastpiit"
                  className="text-gray-400 hover:text-white transition-colors duration-300"
                >
                  <Youtube className="h-8 w-8" />
                </a>
                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/nastp-institute-of-information-technology/posts/?feedView=all"
                  className="text-gray-400 hover:text-white transition-colors duration-300"
                >
                  <Linkedin className="h-8 w-8" />
                </a>
                <a
                  target="_blank"
                  href="https://x.com/nastpiit"
                  className="text-gray-400 hover:text-white transition-colors duration-300"
                >
                  <X className="h-8 w-8" />
                </a>
              </div>
            </div>

            {/* Column 2: Quick Links */}
            <div>
              <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
              <ul className="space-y-3">
                {[
                  { name: "Campus Life", path: "/campus" },
                  { name: "Careers", path: "/careers" },
                ].map((item) => (
                  <li key={item.name}>
                    <Link
                      to={item.path}
                      className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center"
                    >
                      <ChevronRight className="w-4 h-4 mr-2" /> {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 3: Contact */}
            <div>
              <h3 className="text-lg font-semibold mb-6">Contact Us</h3>
              <ul className="space-y-4 text-gray-400">
                <li className="flex items-start">
                  <MapPin className="w-5 h-5 text-gray-400 mr-3 mt-0.5" />
                  69 Abid Majeed Road, Lahore Cantt
                </li>
                <li className="flex items-center">
                  <Phone className="w-5 h-5 text-gray-400 mr-3" />
                  +92 42 36666033
                </li>
                <li className="flex items-center">
                  <Mail className="w-5 h-5 text-gray-400 mr-3" />
                  info@niit.edu.pk
                </li>
                <li className="flex items-center">
                  <Calendar className="w-5 h-5 text-gray-400 mr-3" />
                  Mon–Fri: 9:00 AM – 5:00 PM
                </li>
              </ul>
            </div>

            {/* Column 4: Map */}
            <div>
              <h3 className="text-lg font-semibold mb-6">Visit Us</h3>
              <a
                href="https://maps.app.goo.gl/hkh4xKzfxpw6AMA48"
                target="_blank"
                rel="noopener noreferrer"
                className="block rounded-xl overflow-hidden border border-gray-800 shadow-lg hover:shadow-2xl transition-shadow duration-300"
              >
                {/* <iframe
                  title="NASTP Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3401.06918610377!2d74.38762237540597!3d31.522259674213192!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391905ff74779455%3A0xc3bd14e5debae923!2sNASTP%20Institute%20of%20Information%20Technology!5e0!3m2!1sen!2s!4v1746362782433!5m2!1sen!2s"
                  width="100%"
                  height="220"
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  className="pointer-events-none"
                ></iframe> */}

                {/* <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3401.0691851649453!2d74.3901973!3d31.522259699999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391905ff74779455%3A0xc3bd14e5debae923!2sNASTP%20Institute%20of%20Information%20Technology!5e0!3m2!1sen!2s!4v1746382366995!5m2!1sen!2s"
                  width="100%"
                  height="220"
                  // loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  className="pointer-events-none"
                ></iframe> */}

                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3401.0691851649453!2d74.3901973!3d31.522259699999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391905ff74779455%3A0xc3bd14e5debae923!2sNASTP%20Institute%20of%20Information%20Technology!5e0!3m2!1sen!2s!4v1746383101133!5m2!1sen!2s"
                  width="100%"
                  height="220"
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  className="pointer-events-none"
                ></iframe>
              </a>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="py-6 border-t border-gray-800 text-center text-sm text-gray-400">
            © {new Date().getFullYear()} NASTP Institute of Information
            Technology. All rights reserved.
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
